import createIcon from '../../createIcon';

/**
 * @component @name MonitorHeart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuMTEgMTIuNDVMMTQgMTAuMjRMMTAuODkgMTYuNDVDMTAuNzMgMTYuNzkgMTAuMzggMTcgMTAgMTdDOS42MiAxNyA5LjI3IDE2Ljc5IDkuMTEgMTYuNDVMNy4zOCAxM0gyVjE4QzIgMTkuMSAyLjkgMjAgNCAyMEgyMEMyMS4xIDIwIDIyIDE5LjEgMjIgMThWMTNIMTZDMTUuNjIgMTMgMTUuMjcgMTIuNzkgMTUuMTEgMTIuNDVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjAgNEg0QzIuOSA0IDIgNC45IDIgNlYxMUg4QzguMzggMTEgOC43MyAxMS4yMSA4Ljg5IDExLjU1TDEwIDEzLjc2TDEzLjExIDcuNTVDMTMuNDUgNi44NyAxNC41NiA2Ljg3IDE0LjkgNy41NUwxNi42MiAxMUgyMlY2QzIyIDQuOSAyMS4xIDQgMjAgNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MonitorHeart = createIcon('MonitorHeart', [
  [
    'path',
    {
      d: 'M15.11 12.45L14 10.24L10.89 16.45C10.73 16.79 10.38 17 10 17C9.62 17 9.27 16.79 9.11 16.45L7.38 13H2V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V13H16C15.62 13 15.27 12.79 15.11 12.45Z',
      key: '1lmjh9',
    },
  ],
  [
    'path',
    {
      d: 'M20 4H4C2.9 4 2 4.9 2 6V11H8C8.38 11 8.73 11.21 8.89 11.55L10 13.76L13.11 7.55C13.45 6.87 14.56 6.87 14.9 7.55L16.62 11H22V6C22 4.9 21.1 4 20 4Z',
      key: '2pcqmb',
    },
  ],
]);

export default MonitorHeart;
